const $ = jQuery;

Drupal.behaviors.lfHero = {
    attach: function (context, settings) {
        $('.js-hero-scroll-for-more', context).once('js-hero-scroll-for-more').click(function () {
            const hero = $(this).closest('.lf-hero').first().get(0);
            window.scrollBy({
                top: hero.getBoundingClientRect().bottom,
                behavior: 'smooth',
            });
        });

        function setCircleSize (circle, parentHeight) {
            const index = parseInt(circle.dataset.heroCircleIndex, 10);
            const size = parentHeight * 2 - ( parentHeight / 2 * index );
            circle.style.height = `${size}px`;
            circle.style.width = `${size}px`;
        }

        $('.js-hero-circles', context).once('js-hero-circles').each(function () {
            const $parent = $(this);
            for (let i = 0; i < 4; i++) {
                const circle = document.createElement('div');
                circle.dataset.heroCircleIndex = i.toString(10);
                setCircleSize(circle, $parent.height());
                $parent.append(circle);
            }
        });

        $(window).on('resize', function () {
            $('.js-hero-circles', context).each(function () {
                const $parent = $(this);
                $parent.children('[data-hero-circle-index]').each(function (i, el) {
                    setCircleSize(el, $parent.height())
                });
            });
        })
    },
};
